RivalIQ.apps.CompanyProfile.module('enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    const channels = RivalIQ.enums.channels;
    const sources = RivalIQ.enums.sources;
    const metrics = RivalIQ.metrics.id;

    enums[channels.TWITTER] = {
        source: RivalIQ.enums.sources.TWITTER,
        reportHref: '/overview/twitter',
        reportText: 'Compare Twitter Metrics',
        notFound: 'We did not find a Twitter presence for this company.',
        suggest: 'Twitter handle',
        metrics: [
            metrics.TWITTER_FOLLOWERS,
            metrics.TWITTER_NORMAL_TWEETS,
            metrics.TWITTER_TWEETS_ENGAGEMENT_TOTAL,
            {
                concept: metrics.TWITTER_AVERAGE_TWEET_ENGAGEMENT_RATE,
                valueFormat: RivalIQ.formatter.absolutePercent
            }
        ]
    };
    enums[channels.FACEBOOK] = {
        source: sources.FACEBOOK,
        reportHref: '/overview/facebook',
        reportText: 'Compare Facebook Metrics',
        notFound: 'We did not find a Facebook presence for this company.',
        suggest: 'Facebook page',
        metrics: [
            metrics.FACEBOOK_LIKES,
            metrics.FACEBOOK_POSTS,
            metrics.FACEBOOK_POSTS_ENGAGEMENT_TOTAL,
            {
                concept: metrics.FACEBOOK_AVERAGE_POST_ENGAGEMENT_RATE,
                valueFormat: RivalIQ.formatter.absolutePercent
            }
        ]
    };

    enums[channels.YOUTUBE] = {
        source: sources.YOUTUBE,
        reportHref: '/overview/youtube',
        reportText: 'Compare YouTube Metrics',
        notFound: 'We did not find a YouTube presence for this company.',
        suggest: 'YouTube page',
        metrics: [
            metrics.YOUTUBE_SUBSCRIBERS,
            metrics.YOUTUBE_VIDEOS,
            metrics.YOUTUBE_POSTS_ENGAGEMENT_TOTAL,
            {
                concept: metrics.YOUTUBE_AVERAGE_POST_ENGAGEMENT_RATE,
                valueFormat: RivalIQ.formatter.absolutePercent
            }
        ]
    };

    enums[channels.INSTAGRAM] = {
        source: sources.INSTAGRAM,
        reportHref: '/overview/instagram',
        reportText: 'Compare Instagram Metrics',
        notFound: 'We did not find an Instagram presence for this company.',
        suggest: 'Instagram page',
        metrics: [
            metrics.INSTAGRAM_FOLLOWED_BY,
            metrics.INSTAGRAM_POSTS,
            metrics.INSTAGRAM_POSTS_ENGAGEMENT_TOTAL,
            {
                concept: metrics.INSTAGRAM_AVERAGE_POST_ENGAGEMENT_RATE,
                valueFormat: RivalIQ.formatter.absolutePercent
            }
        ]
    };

    enums[channels.TIKTOK] = {
        source: sources.TIKTOK,
        reportHref: '/overview/tiktok',
        reportText: 'Compare TikTok Metrics',
        notFound: 'We did not find a TikTok presence for this company.',
        suggest: 'TikTok handle',
        metrics: [
            metrics.TIKTOK_FOLLOWERS,
            metrics.TIKTOK_POSTS,
            metrics.TIKTOK_POSTS_ENGAGEMENT_TOTAL,
            {
                concept: metrics.TIKTOK_AVG_ENGAGEMENT_RATE_PER_POST,
                valueFormat: RivalIQ.formatter.absolutePercent
            }
        ]
    };

});
